import { mkTrackAttrs } from '@/analytics/track';
import { ThreadId } from '@/models/Thread';
import { WidgetId } from '@/models/PanelWidgets';

export const CORPUS_QA_PREFIX = 'corpus_qa';

// Download Report Button
export const mkDownloadReportBtnTrackAttrs = (props: {
  threadId: ThreadId;
  widgetId: WidgetId;
}) => mkTrackAttrs(`${CORPUS_QA_PREFIX}__download_report_btn`, props);
